var systemFilter = {};
var systemFilterSlider = $('.js-system-filter-slider');
var systemFilterSliderChildren = systemFilterSlider.find('.system-filter-item').length;
systemFilter.slider = function () {
  systemFilterSlider.on('ready.flickity', function () {
    systemFilterSlider.css('visibility', 'visible');
  });
  var options = {
    cellAlign: 'left',
    prevNextButtons: false,
    pageDots: false,
    dragThreshold: 3,
    selectedAttraction: 0.01,
    friction: 0.15,
    freeScrollFriction: 0.02,
    contain: true
  };
  systemFilterSlider.flickity(options);
};
if (matchMedia('screen and (max-width: 992px)').matches) {
  systemFilterSlider.removeClass('is-open');
  systemFilter.slider();
}
$(window).resize(function () {
  if (matchMedia('screen and (max-width: 992px)').matches) {
    systemFilterSlider.removeClass('is-open');
    systemFilter.slider();
  }
});


// WEBPACK FOOTER //
// ./scripts/components/sliders/system-filter.js